"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useRecordId = void 0;
const router_1 = require("next/router");
function useRecordId() {
    const router = (0, router_1.useRouter)();
    const { recordId } = router.query;
    return recordId;
}
exports.useRecordId = useRecordId;
